import React, { useContext } from "react"
import { BrowserRouter as Router, Switch } from "react-router-dom"

import PrivateRoute from "@Components/PrivateRoute"
import PublicRoute from "@Components/PublicRoute"
import { AuthContext } from "@Context/context/AuthContext"

import DashboardContainer from "../containers/dashboard"
import LoginScreen from "@Pages/login"

const AppRouter = () => {
  const { user } = useContext(AuthContext)
  const logged = user.isLogged

  return (
    <Router>
      <Switch>
        <PublicRoute
          exact
          path="/login"
          component={LoginScreen}
          isAuthenticated={logged}
        />
        <PrivateRoute
          path="/"
          component={DashboardContainer}
          isAuthenticated={logged}
        />
      </Switch>
    </Router>
  )
}

export default AppRouter
